import Recap from 'vcomponents/recap/Recap.vue';
import Feature from 'Services/Feature';

/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

export default [
    {
        path: '/recap-2024',
        name: 'recap2024',
        component: Recap,
        meta: {
            forceTitle: true,
        },
        beforeEnter: (to, from, next) => {
            if (Feature.isEnabled('recap-2024')) {
                next();
            }
        },
    },
];
